// AI健康
import AIHealthIndex from '@/views/smartLife/AIHealth/index'

const antRoutes = Array.from({ length: 22 }, (_, i) => ({
  path: `AIHealth/ant/index${i + 1}`,
  name: `AIHealth/ant/Index${i + 1}`,
  component: () => import(`@/views/smartLife/AIHealth/ant/index${i + 1}.vue`)
}))

export default {
  path: '/smartLife',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'AIHealth/index',
      name: 'AIHealthIndex',
      component: AIHealthIndex
    },
    // AI蚂蚁阿福，开始
    ...antRoutes
    // AI蚂蚁阿福，结束

  ]
}
